import React, { useState } from "react";
import styled from "styled-components";
import iconImage from "../../shared/images/icons/ICON_BLACK_TRANSPARENT.png";
import middleIconImage from "../../shared/images/text/forkedv2newblack.png";

const AppContainer = styled.div`
  background-color: white;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const IconImage = styled.img`
  width: 40px;
  height: 40px;
`;

const MiddleIconImage = styled.img`
  width: 300px;
  height: auto;
`;

const MiddleText = styled.div`
  font-size: 12px;
  text-align: center;
`;

const FooterText = styled.div`
  font-size: 12px;
  text-align: center;
  position: absolute;
  bottom: 20px;
`;

const TextButton = styled.button`
  background: none;
  border: none;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  margin: 0 5px;
  color: black;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ContentContainer = styled.div`
  text-align: center;
  margin: 20px;
`;

function App() {
  const [showAbout, setShowAbout] = useState(false);
  const [showContact, setShowContact] = useState(false);

  const handleBack = () => {
    setShowAbout(false);
    setShowContact(false);
  };

  if (showAbout) {
    return (
      <AppContainer>
        <TextButton onClick={handleBack}>Back</TextButton>
        <MiddleText>
          <br />
          <br />
          Forked Digital is a blockchain and analytics development company with presence in Australia, Singapore and Korea,
          <br />
          running nodes, building DeFi applications, web development, automation tools, and expert in gaming applications,
          <br />
        </MiddleText>
      </AppContainer>
    );
  }

  if (showContact) {
    return (
      <AppContainer>
        <TextButton onClick={handleBack}>Back</TextButton>
        <MiddleText>
          <br />
          <br />
          Contact:
          <br />
          operations@forkeddigital.com
        </MiddleText>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      {/* <IconImage src={iconImage} alt="Icon" />
      <br /> */}
      <MiddleIconImage src={middleIconImage} alt="Middle Icon" />
      <MiddleText>
        <br />
        Blockchain, Sports & Analytics
        <br />
        <br />
        au: Melbourne, asia: Singapore
      </MiddleText>

      <MiddleText>
        <br />
        <br />
        <TextButton onClick={() => setShowAbout(true)}>About</TextButton>
        {"  |  "}
        <TextButton onClick={() => setShowContact(true)}>Contact</TextButton>
      </MiddleText>

      <FooterText>
        <br />
        <br />
        FORKED DIGITAL PTY LTD - ACN 660 719 004
      </FooterText>
      {/* Your website content goes here */}
    </AppContainer>
  );
}

export default App;
